import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import componentNotifier from '../../../services/wss/ComponentNotifier';
import { subscribe } from '../../../services/utils/pubsub';
import { events } from '../../../services/wss/SystemEvents';
import errorCache from './ErrorCache';

const _name = 'ErrorEngine';

// ComponentNotifier event name — ErrorSnack subscribes on this
const _event = 'errorStateChanged';

/**
 * ErrorEngine — receives onError events via pubsub and manages the error queue.
 * CoreBase publishes onError — ErrorEngine catches it here, no circular dependency.
 * Singleton — one instance shared across the app.
 */
class ErrorEngine extends EngineCleanupBase {
    _cache = errorCache;
    _unsubError = null;

    /**
     * Initializes the engine and subscribes to onError pubsub events.
     * Call once at app bootup.
     */
    bootup = () => {
        this.initialize(_name);
        // Subscribe to onError events published by CoreBase.onError
        this._unsubError = subscribe(events.onError, this._onError);
    };

    /**
     * Handles incoming onError pubsub events from CoreBase.
     * Adds error to queue and notifies subscribers.
     * @param {*} payload
     */
    _onError = (payload) => {
        try {
            this._cache.add(payload);
            this._notify();
        } catch (error) {
            this.logError('_onError', error.message);
        }
    };

    /**
     * Dismisses the first error in the queue.
     * Called when user clicks the close button on ErrorSnack.
     * If more errors remain, snack will show the next one automatically.
     */
    dismiss = () => {
        try {
            // TODO aggregate per error
            // this._cache.removeAt(0);
            this._cache.clear();

            this._notify();
        } catch (error) {
            this.logError('dismiss', error.message);
        }
    };

    /**
     * Returns the first error in the queue, or null if empty.
     * @returns {{ source: string, message: string }|null}
     */
    getFirst = () => {
        return this._cache.getFirst();
    };

    /**
     * Returns true if there are errors in the queue.
     * @returns {boolean}
     */
    hasErrors = () => {
        return !this._cache.isEmpty();
    };

    // ─── private ──────────────────────────────────────────

    _notify = () => {
        componentNotifier.notify(_event, _name, {
            error: this._cache.getFirst(),
        });
    };
}

const errorEngine = new ErrorEngine();
export default errorEngine;
